import {createFeatureFlagsStore} from '#imports';

export const FeatureFlags = [
    'advanced-search-profile-card-v2',
    'advanced-search-refinement-criteria',
    'advanced-search-calibration-page',
    'one-entry-point-improvements',
] as const;
export type FeatureFlag = (typeof FeatureFlags)[number];

/** Register features-flags at load
 * Store is initialized in `src/plugins/load-feature-flags`
 */
export const useFeatureFlagsStore = createFeatureFlagsStore([...FeatureFlags], 'search-feature-flags-store');
